import moment from "moment";
import { mapState } from "vuex";
import { convertObjectToParams } from "../../../components/commons/commons";

export default {
  name: "AddMemberModal",
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    dataRecord: {
      type: Object,
      default: function () {
        return {};
      },
    },
    handleCancel: Function,
  },
  data() {
    return {
      formRQ: this.$form.createForm(this, {
        name: "formRQ",
      }),
      formData: {},
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16, offset: 1 },
      },
      isLoading: false,
      timeoutAllStaff: null,
      columns: [
        {
          title: "LDAP",
          dataIndex: "rs_user_name",
          type: "text",
        },
        {
          title: "Member Full Name",
          dataIndex: "rs_full_name",
          type: "text",
        },
        {
          title: "Action",
          width: "15%",
          dataIndex: "action",
          type: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      dataSource: [],
    };
  },
  computed: {
    ...mapState({
      employeeList: (state) => state.application.employeeList,
      getListDetailProject: (state) => state.settings.getListDetailProject,
    }),
  },
  created() {
    if (this.dataRecord) {
      this.onHandleGetDetail()
    }
  },
  methods: {
    moment,
    onOK() {
      if (!this.dataRecord.is_back_office) return
      this.formRQ.validateFields((err, values) => {
        if (err) return;
        const slugPayload = {
          members: values.members
            ? values.members.map((item) => {
                return { username: item };
              })
            : [],
        };

        const payload = {
          projectId: this.dataRecord.project_id,
          members: slugPayload.members,
        };
        this.$store
          .dispatch("settings/addMemberToProject", payload)
          .then(() => {
            this.$message.success("Add member to project successfully !");
            this.formRQ.resetFields();
            this.onHandleGetDetail();
            this.$emit("onGetListProject");
          })
          .catch((err) => {
            this.$message.error(err.response.data.message || err.message, 5);
          });
      });
    },

    onHandleGetDetail() {
      this.$store
        .dispatch("settings/getListDetailProject", this.dataRecord.id)
        .then((res) => {
          if (res) {
            this.dataSource = res.resources;
          }
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },

    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      this.isLoading = true;
      clearTimeout(this.timeoutAllStaff);
      this.timeoutAllStaff = setTimeout(() => {
        this.$store
          .dispatch("application/getEmployeeList", cloneVal)
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }, timeout);
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    onCancel() {
      this.handleCancel();
      this.formRQ.resetFields();
    },

    //List
    showDelete(record) {
      if (!this.dataRecord.is_back_office) return
      this.$confirm({
        title: "Confirm",
        content: "Do you want to delete this member?",
        okText: "Yes",
        onOk: () => {
          this.deleteMember(record);
        },
        cancelText: "No",
      });
    },
    deleteMember(record) {
      const payload = {
        id: this.dataRecord.id,
        username: record.rs_user_name,
      };

      const url = convertObjectToParams(payload);
      this.$store
        .dispatch("settings/deleteMemberToProject", url)
        .then(() => {
          this.$message.success("Delete member successfully !");
          this.onHandleGetDetail();
          this.$emit("onGetListProject");
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },
  },
};
